/**
 * @generated SignedSource<<edc389e376783d29d293612bd586a22a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type amChartsUtils_useRoot$data = {
  readonly currentUser: {
    readonly isAdmin: boolean;
  };
  readonly " $fragmentType": "amChartsUtils_useRoot";
};
export type amChartsUtils_useRoot$key = {
  readonly " $data"?: amChartsUtils_useRoot$data;
  readonly " $fragmentSpreads": FragmentRefs<"amChartsUtils_useRoot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "amChartsUtils_useRoot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "723708de8784b5712d8d9bb304bdcb0b";

export default node;
